import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { catalogBibShape, listShape, userIdentityShape, libraryShape } from '@bibliocommons/bc-prop-types';
import { SecondaryGhostLink } from '@bibliocommons/base-links';

import ListsRow from './ListsRow';

import './StaffLists.scss';

export default class StaffLists extends React.PureComponent {
  renderAllListsLink() {
    const { catalogBib } = this.props;
    const metadataId = catalogBib.get('metadataId');

    return (
      <SecondaryGhostLink
        className="cp-all-lists-link"
        dataKey="all-lists-link"
        href={`/v2/record/${metadataId}/lists`}
      >
        <FormattedMessage id="view_all_lists" />
      </SecondaryGhostLink>
    );
  }

  renderLists() {
    const { lists, library, users } = this.props;

    if (lists.size <= 2) {
      return (
        <div>
          <h2 className="staff-lists-heading">
            <FormattedMessage id="staff_lists_featuring_title" />
          </h2>
          <ListsRow lists={lists} stacked users={users} library={library} />
        </div>
      );
    }

    return (
      <div>
        <h2 className="staff-lists-heading">
          <FormattedMessage id="staff_lists_featuring_title" />
        </h2>
        <ListsRow key="desktop" className="lists-desktop" lists={lists.take(4)} library={library} users={users} />
        <ListsRow key="mobile" className="lists-mobile" lists={lists} stacked library={library} users={users} />
      </div>
    );
  }

  render() {
    const { lists } = this.props;
    if (!lists.size) return null;

    return (
      <div className="cp-staff-lists">
        {this.renderLists(lists)}
        <div className="view-all-link">{this.renderAllListsLink()}</div>
      </div>
    );
  }
}

StaffLists.propTypes = {
  catalogBib: catalogBibShape,
  users: ImmutablePropTypes.mapOf(userIdentityShape),
  lists: ImmutablePropTypes.listOf(listShape).isRequired,
  library: libraryShape
};
